import React from 'react';
import MockCard from './mock-card/MockCard';

const MockIndex = () => {
    return (
        <>
         <MockCard />   
        </>
    );
};

export default MockIndex;